import * as types from './action-types';
import { sortBy, find, filter, range } from 'lodash';
import $ from 'jquery';

import { 
  setName, 
  setBirth, 
  setDeath, 
  setPersonId, 
  batchUpdateCells, 
  clearAllCellsData,
  clearAncestorData,
} from '../cells'

const FS = new window.FamilySearch({
  app_key: 'a02j000000LsGIWAA3',
  auth_callback: process.env.NODE_ENV === 'production' ? 'https://app.familytreeprints.com' : 'http://localhost:3000',
  environment: 'production',
  http_function: $.ajax,
  deferred_function: $.Deferred,
  save_access_token: true,
});

export function familySearchSignIn() {
  return dispatch => {
    FS.getAccessToken().then(token => {
      // FS.getCurrentUser().then(response => {
      //   const email = response.getUser().data.email;
      // })
      FS.getCurrentUserPerson().then(response => {
        const person = response.getPerson();
        const _person = parsePerson(person);
        person.getSpouses()
        .then(response => {
          const spouse = response.getData().persons[0];
          const isFemale = person.getGender().data.type.toLowerCase().indexOf('female') >= 0;
          const child = {
            name: 'Child of ' + _person.name,
            birth: '',
            death: '',
            father: !isFemale ? _person : parsePerson(spouse),
            mother: isFemale ? _person : parsePerson(spouse),
            ascendancyNumber: 1,
          }
          dispatch(setPossibleRoots([child, child.father, child.mother]));
          dispatch(setToken(token));
        })
        .catch(response => {
          _person.ascendancyNumber = 1;
          dispatch(setPossibleRoots([_person]));
          dispatch(setToken(token));
        })
      })
    });
  }
}

export function familySearchSignOut() {
  return dispatch => {
    FS.invalidateAccessToken();
    dispatch(setToken(null));
  }
}

export function setToken(token) {
  return {
    type: types.SET_FAMILY_SEARCH_TOKEN,
    payload: token,
  }
}

export function setPossibleRoots(roots) {
  return {
    type: types.SET_POSSIBLE_ROOTS,
    payload: roots,
  }
}

export function importPersonAncestors(person, generations, showFirstGeneration) {
  return dispatch => {

    if(person.personId) {
      dispatch(clearAllCellsData());
      FS.getPerson(person.personId).then(response => {
        const _person = parsePerson(response.getPerson());
        _person.ascendancy = 1;
        fetchAncestors(dispatch, _person, generations - 1);
        if(showFirstGeneration) {
          dispatch(batchUpdateCells([_person]));
        }
      })
    } else {
      person.ascendancy = 1;

      const parents = [person.father, person.mother];
      parents.forEach((parent, i) => {
        if(parent) {
          parent.ascendancy = 2 + i;
          if(!parent.unknown) {
            dispatch(clearAncestorData(parent));
          }
        }
      })
      
      dispatch(batchUpdateCells(parents));

      fetchAncestors(dispatch, person.father, generations - 2);
      fetchAncestors(dispatch, person.mother, generations - 2);
    }
  }
}

export function fetchAncestors(dispatch, person, generations) {
  if(generations <= 1 || person.unknown) {
    return;
  }

  if(person.father === undefined || person.mother === undefined) {
    const n = generations > 8 ? generations - 8 : generations; // API only supports 8 generations
    FS.getAncestry(person.personId, {generations: n, personDetails: true})
    .then(response => {
      const ancestors = response.getPersons().map(parsePerson);
      linkAncestors(person, ancestors, n);
      const list = [];
      ancestryToList(person, list);
      dispatch(batchUpdateCells(filter(list, ({ascendancy}) => ascendancy > 1)));

      fetchAncestors(dispatch, person.father, generations - 1);
      fetchAncestors(dispatch, person.mother, generations - 1);
    })
  } else {
    fetchAncestors(dispatch, person.father, generations - 1);
    fetchAncestors(dispatch, person.mother, generations - 1);
  }
}

export function parsePerson(person) {
  const p = person;
  return {
    name: person.getDisplayName(),
    birth: person.getBirthDate && parseYear(person.getBirthDate()),
    death: person.getDeathDate && parseYear(person.getDeathDate()),
    personId: person.getPersonId ? person.getPersonId() : person.getId(),
    ascendancy: person.getAscendancyNumber && parseAscendancy(person.getAscendancyNumber()),
  }
}



export function ancestryToList(person, result) {
  result.push(person);
  if(person.father) {
    ancestryToList(person.father, result);
  }
  if(person.mother) {
    ancestryToList(person.mother, result);
  }
}

function linkAncestors(person, ancestors, maxGenerations) {
  const actualAscendancy = person.ascendancy;
  person.ascendancy = 1;
  
  const highestChild = Math.pow(2, maxGenerations);
  const _ancestors = [
    person,
    ...filter(ancestors, ancestor => ancestor.ascendancy !== 1)
  ];

  _ancestors.forEach(_person => {
    const father = find(_ancestors, ancestor => ancestor.ascendancy === _person.ascendancy * 2);
    const mother = find(_ancestors, ancestor => ancestor.ascendancy === _person.ascendancy * 2 + 1);
    if(father) {
      _person.father = father;
    } else if(_person.ascendancy < highestChild) {
      _person.father = {unknown: true};
    }

    if(mother) {
      _person.mother = mother;
    } else if(_person.ascendancy < highestChild) {
      _person.mother = {unknown: true};
    }
  })

  person.ascendancy = actualAscendancy;
  correctAscendancy(person);
}

export function correctAscendancy(person) {
  if(person.father) {
    person.father.ascendancy = person.ascendancy * 2;
    correctAscendancy(person.father);
  }
  if(person.mother) {
    person.mother.ascendancy = person.ascendancy * 2 + 1;
    correctAscendancy(person.mother);
  }
}

function parseAscendancy(ascendancy) {
  return Number.parseInt(ascendancy);
}

export function parseYear(dateStr) {
  const re = /(\d{4})/g;
  const matches = (dateStr || '').match(re);
  return matches && matches[0];
}




// WEBPACK FOOTER //
// ./src/core/family-search/actions.js